import { render, staticRenderFns } from "./ListActionNotEnded.vue?vue&type=template&id=50bdfc71"
import script from "./ListActionNotEnded.vue?vue&type=script&lang=js"
export * from "./ListActionNotEnded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports